<template>
    <main class="base-f relative flex-row-start-start">
        <TooltipProvider :delayDuration="300">
        <section id="s1">
            <header class="expand-x flex-row-start-center">
                <a :href="staticURL('')" class="logobox flex-row-start-center">
                    <img class="expand-y" :src="companyLogoLight">
                </a>
            </header>
            <div class="body relative">

                <div class="flex-row-center-center steppers">
                <StepperRoot :model-value="step" :default-value="1" class="flex-row-start-start _4">
                    <motion.div v-for="item in steps" :key="item.step" layout :transition="{ type: 'spring', stiffness: 300, damping: 30 }">
                    <StepperItem class="StepperItem flex-row-center-center" :step="item.step">
                        <StepperTrigger class="StepperTrigger flex-col-start-center _12">
                            <StepperIndicator class="StepperIndicator">
                                <Icon v-if="item.step != 1" :icon="item.icon" class="StepperIcon"></Icon>
                                <svg v-if="item.step === 1" version="1.0" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                                    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                    fill="#000000" stroke="none">
                                    <path d="M2334 4898 c-562 -571 -991 -1143 -1244 -1663 -250 -513 -320 -929
                                    -228 -1355 146 -676 690 -1208 1371 -1339 59 -12 124 -21 143 -21 l34 0 0
                                    -260 0 -260 150 0 150 0 0 259 0 258 63 6 c211 20 517 127 701 245 602 388
                                    918 1076 801 1748 -105 602 -528 1332 -1214 2094 -102 114 -492 510 -502 510
                                    -3 0 -104 -100 -225 -222z m76 -980 l0 -623 -287 287 -287 287 56 73 c141 183
                                    497 598 513 598 3 0 5 -280 5 -622z m475 437 c129 -146 395 -472 395 -484 0
                                    -3 -128 -134 -285 -291 l-285 -285 0 624 0 624 21 -19 c12 -10 81 -86 154
                                    -169z m-475 -1985 l0 -505 -556 556 -556 556 55 114 c62 128 165 310 251 443
                                    l58 89 374 -374 374 -374 0 -505z m1178 1047 c50 -84 123 -217 163 -296 l72
                                    -143 -557 -557 -556 -556 0 505 0 505 373 373 372 373 21 -26 c11 -14 61 -94
                                    112 -178z m-1786 -1364 l608 -608 0 -312 0 -313 -25 0 c-46 0 -177 31 -282 65
                                    -212 71 -392 183 -558 350 -210 209 -333 438 -396 735 -26 124 -32 382 -10
                                    490 24 126 43 200 49 200 4 0 280 -273 614 -607z m2152 540 c35 -159 40 -205
                                    40 -358 -1 -227 -40 -401 -135 -604 -129 -275 -380 -531 -657 -670 -133 -67
                                    -379 -141 -467 -141 l-25 0 0 312 0 313 607 607 c335 335 611 608 615 608 3 0
                                    13 -30 22 -67z"/>
                                    </g>
                                </svg>                                
                            </StepperIndicator>
                            <div class="StepperItemText">
                                <StepperTitle class="base-ft force-mako font-m relative">
                                    {{ item.title }}
                                </StepperTitle>
                            </div>
                        </StepperTrigger>
                    </StepperItem>
                    </motion.div>
                </StepperRoot>
                </div>

                <div class="card relative">
                    <h1 class="title embrace-mid expand-x">
                        Signups are temporarily down
                    </h1>
                    <motion.div class="cardSection expand-x flex-col-start-start _6">
                        <div class="base-f font-s error-message expand-x flex-row-center-center" style="text-align: center;">
                            We're sorry, doored is temporarily closed for future signups
                            <br>
                            due to site maintenance.
                            Come back at a later date.
                        </div>
                    </motion.div>
<!--                     <button :class="{mountTop: step===2}" @click="goBack" v-if="step!=3 && stage!=RegisterStages.OPTIONS && !loadingSignup && stage != RegisterStages.PAY_SUCCEDED && stage != RegisterStages.PAY_FAILED && stage != RegisterStages.SPRING_2FA && stage != RegisterStages.SUMMER_2FA && !signupData.is_graduating" class="backStage">
                        <Icon icon="radix-icons:chevron-up" class="icon"></Icon>
                    </button> -->
<!--                     <h1 class="title embrace-mid expand-x" v-if="!loadingSignup && paymentStatus.length === 0 && !signupData.show_recovery">{{stageData.title}}</h1>
                    <h1 class="title embrace-mid expand-x" v-if="!loadingSignup && paymentStatus.length === 0 && signupData.show_recovery">Your recovery codes</h1>
                    <h1 class="title embrace-mid expand-x" v-if="!loadingSignup && paymentStatus.length != 0">{{paymentStatus}}</h1>
                     -->
<!--                     <motion.div class="cardSection expand-x flex-col-start-start _6" v-show="stage===RegisterStages.OPTIONS" :transition="{visualDuration: 0.3}" :animate="{opacity: stage===RegisterStages.OPTIONS ? 1 : 0}">
                        <button @click="chooseStage(RegisterStages.SPRING_PACKS); signupData.account_type = AccountType.SPRING" class="action s-btn btn-foreground"><span class="base-ft">I want to prepare for Spring weeks</span></button>
                        <button @click="chooseStage(RegisterStages.SUMMER_PACKS); signupData.account_type = AccountType.SUMMER" class="action s-btn btn-background"><span class="base-ft">I want to prepare for Summer/Grad roles</span></button>
                        <div v-if="timeOutError" class="base-f font-s error-message expand-x flex-row-center-center" style="text-align: center;">
                            It seems like your signup window timed out. To protect your data 
                            your signup window is only valid for a limited amount of time after
                            you've started the signup process. Please try again.
                        </div>                          
                    </motion.div>
 -->
<!--                     <motion.div class="cardSection expand-x flex-col-start-start _6" v-show="stage===RegisterStages.SPRING_PACKS||stage===RegisterStages.SUMMER_PACKS" :transition="{visualDuration: 0.3}" :animate="{opacity: stage===RegisterStages.SPRING_PACKS||stage===RegisterStages.SUMMER_PACKS ? 1 : 0}">
                        <button @click="chooseStage(stage === RegisterStages.SUMMER_PACKS ? RegisterStages.SUMMER_FORM : RegisterStages.SPRING_FORM); signupData.permission=AccountPermissionType.PREPPACK" class="action s-btn btn-foreground"><span class="base-ft">doored <i>{{ stageData.options ? stageData.options[0] : 'Pre-built pack' }}</i></span></button>
                        

                        <TooltipRoot @update:open="handleEmailErrorToolTip" :open="showEmailError && step == 1">
                            <TooltipTrigger as="button" id="m-flex" class="action s-btn btn-background noallow">
                                <span class="base-ft">Build my own pack</span>
                                <TooltipPortal>
                                    <AnimatePresence>
                                    <TooltipContent :side-offset="5" side="right" :align="'start'" style="z-index: 999 !important;">
                                        <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                            Custom packs are temporarily disabled
                                        </motion.div>
                                    </TooltipContent>
                                    </AnimatePresence>
                                </TooltipPortal>
                            </TooltipTrigger>
                        </TooltipRoot>

                        <TooltipRoot @update:open="handleToolTipOpenPromoQuestion" :open="showPromoQuestion && step == 1">
                            <TooltipTrigger as="button" id="m-flex" class="action s-btn btn-background noallow">
                                <span class="base-ft">Try for free</span>
                                <TooltipPortal>
                                    <AnimatePresence>
                                    <TooltipContent :side-offset="5" side="right" :align="'start'" style="z-index: 999 !important;">
                                        <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                            Free packs are temporarily disabled
                                        </motion.div>
                                    </TooltipContent>
                                    </AnimatePresence>
                                </TooltipPortal>
                            </TooltipTrigger>
                        </TooltipRoot>

                        <button id="m-flex" @click="chooseStage(stage === RegisterStages.SUMMER_PACKS ? RegisterStages.SUMMER_BUILD : RegisterStages.SPRING_BUILD); signupData.permission=AccountPermissionType.BUILD" class="action s-btn btn-background"><span class="base-ft">Build my own pack</span></button>
                        
                        <button @click="chooseStage(stage === RegisterStages.SUMMER_PACKS ? RegisterStages.SUMMER_FORM : RegisterStages.SPRING_FORM); signupData.permission=AccountPermissionType.FREE" class="action s-btn btn-background"><span class="base-ft">Try for free</span></button>
                    </motion.div>
 -->
                    <!-- <motion.div class="cardSection signed expand-x flex-col-start-start _6" v-show="stage===RegisterStages.SPRING_BUILD||stage===RegisterStages.SUMMER_BUILD" :transition="{visualDuration: 0.3}" :animate="{opacity: RegisterStages.SPRING_BUILD||RegisterStages.SUMMER_BUILD ? 1 : 0}">
                        <div class="checkoutItem">
                            <div class="ico">
                                <svg v-if="stage===RegisterStages.SPRING_BUILD" version="1.0" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                                    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                    fill="#000000" stroke="none">
                                    <path d="M2334 4898 c-562 -571 -991 -1143 -1244 -1663 -250 -513 -320 -929
                                    -228 -1355 146 -676 690 -1208 1371 -1339 59 -12 124 -21 143 -21 l34 0 0
                                    -260 0 -260 150 0 150 0 0 259 0 258 63 6 c211 20 517 127 701 245 602 388
                                    918 1076 801 1748 -105 602 -528 1332 -1214 2094 -102 114 -492 510 -502 510
                                    -3 0 -104 -100 -225 -222z m76 -980 l0 -623 -287 287 -287 287 56 73 c141 183
                                    497 598 513 598 3 0 5 -280 5 -622z m475 437 c129 -146 395 -472 395 -484 0
                                    -3 -128 -134 -285 -291 l-285 -285 0 624 0 624 21 -19 c12 -10 81 -86 154
                                    -169z m-475 -1985 l0 -505 -556 556 -556 556 55 114 c62 128 165 310 251 443
                                    l58 89 374 -374 374 -374 0 -505z m1178 1047 c50 -84 123 -217 163 -296 l72
                                    -143 -557 -557 -556 -556 0 505 0 505 373 373 372 373 21 -26 c11 -14 61 -94
                                    112 -178z m-1786 -1364 l608 -608 0 -312 0 -313 -25 0 c-46 0 -177 31 -282 65
                                    -212 71 -392 183 -558 350 -210 209 -333 438 -396 735 -26 124 -32 382 -10
                                    490 24 126 43 200 49 200 4 0 280 -273 614 -607z m2152 540 c35 -159 40 -205
                                    40 -358 -1 -227 -40 -401 -135 -604 -129 -275 -380 -531 -657 -670 -133 -67
                                    -379 -141 -467 -141 l-25 0 0 312 0 313 607 607 c335 335 611 608 615 608 3 0
                                    13 -30 22 -67z"/>
                                    </g>
                                </svg>
                                <svg v-if="stage===RegisterStages.SUMMER_BUILD" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30"><path fill="#000" d="M4.37 14.62c0-.24.08-.45.25-.62c.17-.16.38-.24.6-.24h2.04c.23 0 .42.08.58.25c.15.17.23.37.23.61s-.07.44-.22.61s-.35.25-.58.25H5.23c-.23 0-.43-.08-.6-.25a.83.83 0 0 1-.26-.61m2.86 6.93c0-.23.08-.43.23-.61l1.47-1.43c.15-.16.35-.23.59-.23s.44.08.6.23s.24.34.24.57c0 .24-.08.46-.24.64L8.7 22.14q-.615.48-1.23 0a.8.8 0 0 1-.24-.59m0-13.84c0-.23.08-.43.23-.61c.2-.17.41-.25.64-.25c.22 0 .42.08.59.24l1.43 1.47c.16.15.24.35.24.59q0 .36-.24.6c-.24.24-.36.24-.6.24s-.44-.08-.59-.24L7.47 8.32a.84.84 0 0 1-.24-.61m2.55 6.91c0-.93.23-1.8.7-2.6s1.1-1.44 1.91-1.91s1.67-.7 2.6-.7c.7 0 1.37.14 2.02.42c.64.28 1.2.65 1.66 1.12c.47.47.84 1.02 1.11 1.66s.41 1.32.41 2.02c0 .94-.23 1.81-.7 2.61s-1.1 1.43-1.9 1.9s-1.67.7-2.61.7s-1.81-.23-2.61-.7s-1.43-1.1-1.9-1.9c-.45-.81-.69-1.68-.69-2.62m1.7 0c0 .98.34 1.81 1.03 2.5c.68.69 1.51 1.04 2.49 1.04s1.81-.35 2.5-1.04s1.04-1.52 1.04-2.5c0-.96-.35-1.78-1.04-2.47c-.69-.68-1.52-1.02-2.5-1.02c-.97 0-1.8.34-2.48 1.02c-.7.69-1.04 1.51-1.04 2.47m2.66 7.78c0-.24.08-.44.25-.6s.37-.24.6-.24c.24 0 .45.08.61.24s.24.36.24.6v1.99c0 .24-.08.45-.25.62s-.37.25-.6.25s-.44-.08-.6-.25a.85.85 0 0 1-.25-.62zm0-15.5V4.86c0-.23.08-.43.25-.6S14.76 4 15 4s.43.08.6.25s.25.37.25.6V6.9c0 .23-.08.42-.25.58s-.37.23-.6.23s-.44-.08-.6-.23s-.26-.35-.26-.58m5.52 13.18c0-.23.08-.42.23-.56c.15-.16.34-.23.56-.23c.24 0 .44.08.6.23l1.46 1.43c.16.17.24.38.24.61s-.08.43-.24.59q-.6.465-1.2 0l-1.42-1.42a.97.97 0 0 1-.23-.65m0-10.92c0-.25.08-.45.23-.59l1.42-1.47a.84.84 0 0 1 .59-.24c.24 0 .44.08.6.25c.17.17.25.37.25.6c0 .25-.08.46-.24.62l-1.46 1.43q-.27.24-.6.24c-.23 0-.41-.08-.56-.24s-.23-.36-.23-.6m2.26 5.46c0-.24.08-.44.24-.62q.24-.24.57-.24h2.02c.23 0 .43.09.6.26s.26.37.26.6s-.09.43-.26.6s-.37.25-.6.25h-2.02c-.23 0-.43-.08-.58-.25s-.23-.36-.23-.6" stroke-width="1" stroke="#000"/></svg>
                            </div>
                            <div class="item">
                                <p class="StepperTitle base-ft force-mako font-m relative">doored <i>{{ stage==='spring_build' ? 'Spring' : 'Summer/Grad' }}</i></p>
                                <span class="font-s base-ft force-mako relative">{{ firmNumber }} {{ buildFirmsNumberPrefix }}</span>
                            </div>
                            <div class="holdamount">
                                <div class="amount font-m base-ft relative">£{{ pack ? pack.length * 12 : 0 }}</div>
                            </div>
                        </div>
                        <div class="amountRow">
                            <p class="base-ft force-mako font-m relative StepperTitle build">Total due</p>
                            <div class="holdamount">
                                <span class="amount font-m base-ft relative">
                                    £{{ pack ? pack.length * 12 : 0 }}
                                </span>
                            </div>
                        </div>
                        <div style="width: 100%; display: flex; position: relative; justify-content: start; z-index: 999;">
                        <TooltipRoot @update:open="handleToolTipOpenPromoQuestion">
                            <TooltipTrigger as="p" class="base-f force-mako font-m relative StepperTitle promo-question" style="cursor: default;">
                                Where's my promo code? 
                            </TooltipTrigger>
                            <TooltipPortal>
                                <AnimatePresence>
                                <TooltipContent v-if="showPromoQuestion" :side-offset="5" side="top" :align="'start'" style="z-index: 999 !important;">
                                    <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                        Promos are not offered for custom packs
                                        <TooltipArrow class="base-ft force-mako font-m relative tooltipArrow StepperTitle" style="fill: #fff !important;" :width="8"></TooltipArrow>
                                    </motion.div>
                                </TooltipContent>
                                </AnimatePresence>
                            </TooltipPortal>
                        </TooltipRoot>                
                        </div>                    
                        <button @click="handleBuildReady()" class="action build s-btn btn-foreground" :class="{disabled: pack.length < 1}">
                            <span class="base-ft">I'm happy with this pack</span>
                        </button>
                    </motion.div>              -->

<!--                     <motion.div v-show="(stage==='summer_form'||stage==='spring_form') && !(loadingSignup) && !showEmailInputValidationFailure" :transition="{visualDuration: 0.3}" :animate="{opacity: !loadingSignup && !showEmailInputValidationFailure ? 1 : 0}">
                        <form class="cardSection expand-x flex-col-start-start _6" @submit.prevent="initiate_emailSignup()" novalidate>

                        <TooltipRoot @update:open="handleEmailErrorToolTip" :open="showEmailError">
                            <TooltipTrigger as="div" class="inputRow" :class="{invalid: !validEmail && !emailEmpty}" @click="focusInputs.email.focus()">
                                <span class="prefix force-mako font-s base-f expand-x">Email</span>
                                <input :ref="el => focusInputs.email=el" type="email" v-model="signupData.email" @input="validateEmail()" required class="emailInput base-f font-m expand-x relative">
                                <div class="check">
                                    <div v-if="checkingEmail" class="loader input"></div>
                                    <Icon v-if="validEmail && !checkingEmail && emailChecked && !emailEmpty" icon="clarity:success-line" class="checkIcon success"></Icon>
                                    <Icon v-if="!validEmail && !checkingEmail && emailChecked && !emailEmpty" icon="material-symbols:error-outline" class="checkIcon error"></Icon>                                
                                    <TooltipPortal v-if="!validEmail && !checkingEmail && emailChecked && !emailEmpty">
                                        <AnimatePresence>
                                        <TooltipContent v-if="showEmailError" :side-offset="5" side="right" :align="'start'" style="z-index: 999 !important;">
                                            <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                                {{emailMessage}}
                                            </motion.div>
                                        </TooltipContent>
                                        </AnimatePresence>
                                    </TooltipPortal>
                                </div>                                
                            </TooltipTrigger>
                        </TooltipRoot>

                        <TooltipRoot @update:open="handleConflictingUsername" :open="showConflictingUsername">
                            <TooltipTrigger as="div" class="inputRow" :class="{invalid: !validUsername && !usernameEmpty}" @click="focusInputs.username.focus()">
                                <span class="prefix force-mako font-s base-f expand-x">Username</span>
                                <input :ref="el => focusInputs.username=el" type="text" v-model="signupData.username" @input="validateUsername()" required class="emailInput base-f font-m expand-x relative">
                                <div class="check">
                                    <div v-if="checkingUsername" class="loader input"></div>
                                    <Icon v-if="validUsername && !checkingUsername && usernameChecked && !usernameEmpty" icon="clarity:success-line" class="checkIcon success"></Icon>
                                    <Icon v-if="!validUsername && !checkingUsername && usernameChecked && !usernameEmpty" icon="material-symbols:error-outline" class="checkIcon error"></Icon>
                                    <TooltipPortal v-if="!validUsername && !checkingUsername && usernameChecked && !usernameEmpty">
                                        <AnimatePresence>
                                        <TooltipContent v-if="showConflictingUsername" :side-offset="5" side="right" :align="'start'" style="z-index: 999 !important;">
                                            <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                                {{ usernameMessage }}
                                            </motion.div>
                                        </TooltipContent>
                                        </AnimatePresence>
                                    </TooltipPortal>
                                </div>
                            </TooltipTrigger>
                        </TooltipRoot>

                        <TooltipRoot @update:open="handleInvalidPasswordTool" :open="showInvalidPasswordTool">
                            <TooltipTrigger id="lrow" as="div" class="inputRow" :class="{invalid: !validPassword && !passwordEmpty}" @click="focusInputs.password.focus()">
                                <span class="prefix force-mako font-s base-f expand-x">Password</span>
                                <input v-model="signupData.password" :ref="el => focusInputs.password = el" @input="validatePassword()" type="password" required class="emailInput base-f font-m expand-x relative">                                
                                <div class="check">
                                    <div v-if="checkingPassword" class="loader input"></div>
                                    <Icon v-if="validPassword && !checkingPassword && passwordChecked && !passwordEmpty" icon="clarity:success-line" class="checkIcon success"></Icon>
                                    <Icon v-if="!validPassword && !checkingPassword && passwordChecked && !passwordEmpty" icon="material-symbols:error-outline" class="checkIcon error"></Icon>
                                    <TooltipPortal v-if="!validPassword && !checkingPassword && passwordChecked && !passwordEmpty">
                                        <AnimatePresence>
                                        <TooltipContent v-if="showInvalidPasswordTool" :side-offset="5" side="right" :align="'start'" style="z-index: 999 !important;">
                                            <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                                Password must be at least 8 characters
                                            </motion.div>
                                        </TooltipContent>
                                        </AnimatePresence>
                                    </TooltipPortal>
                                </div>
                            </TooltipTrigger>
                        </TooltipRoot>

                        <button :class="{disabled: !validInputs}" class="action s-btn btn-foreground" type="submit">
                            <span class="base-ft">Sign up</span>
                        </button>
                        <div class="expand-x flex-row-center-center relative">
                            <div class="line"></div>
                            <span class="font-s base-ft force-mako" style="padding: 0 12px;">OR</span>
                            <div class="line"></div>
                        </div>
                        <button @click="googleSignup()" class="action s-btn btn-background">
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M13.8824 7.41113H8.11768V9.72516H11.4231C11.3564 10.0945 11.2134 10.4465 11.0029 10.7595C10.7925 11.0726 10.5191 11.34 10.1995 11.5454V13.051H12.1665C12.7703 12.4802 13.2452 11.7912 13.5605 11.0286C14.0327 9.88636 14.0878 8.62111 13.8824 7.41113Z" fill="#4285F4"></path><path d="M8.11765 14.4996C9.76488 14.4996 11.1599 13.9718 12.1665 13.0506L10.1995 11.545C9.58012 11.9375 8.85452 12.1373 8.11765 12.1181C7.35471 12.1088 6.61379 11.8656 5.99848 11.4224C5.38317 10.9793 4.92424 10.3584 4.68585 9.64648H2.65015V11.1856C3.15915 12.1814 3.94 13.0187 4.9055 13.604C5.87099 14.1892 6.98311 14.4992 8.11765 14.4996Z" fill="#34A853"></path><path d="M4.68589 9.64706C4.42873 8.90009 4.42873 8.09081 4.68589 7.34384V5.79395H2.65019C2.22264 6.63065 2 7.55387 2 8.49004C2 9.42621 2.22264 10.3494 2.65019 11.1861L4.68589 9.64706Z" fill="#FBBC04"></path><path d="M8.11765 4.87211C8.98898 4.85751 9.83116 5.18027 10.4621 5.77064L12.2126 4.05185C11.5147 3.43218 10.6808 2.9789 9.77551 2.72723C8.87026 2.47556 7.91812 2.43227 6.99307 2.60073C6.06803 2.76919 5.19498 3.14487 4.44177 3.69857C3.68856 4.25226 3.07548 4.96907 2.65015 5.7933L4.68585 7.34371C4.92424 6.63182 5.38317 6.0109 5.99848 5.56776C6.61379 5.12461 7.35471 4.8814 8.11765 4.87211Z" fill="#EA4335"></path></svg>
                            <span class="base-ft">Sign up with Google</span>
                        </button>
                        </form>
                    </motion.div>
  -->                   
<!--                     <motion.div v-show="(stage==='summer_form'||stage==='spring_form') && !(loadingSignup) && showEmailInputValidationFailure" :transition="{visualDuration: 0.3}" :animate="{opacity: !loadingSignup && showEmailInputValidationFailure ? 1 : 0}">
                        <div class="flex-col-center-center _12 expand-x">
                            <svg id="status-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><g fill="none" stroke="#fa4b4b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path stroke-dasharray="64" stroke-dashoffset="64" d="M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0"/></path><path stroke-dasharray="8" stroke-dashoffset="8" d="M12 12l4 4M12 12l-4 -4M12 12l-4 4M12 12l4 -4"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.6s" dur="0.2s" values="8;0"/></path></g></svg>        
                            <div class="font-s force-mako qrtext">
                                An unexpected error occurred, we'll delete your data.
                                Try again, and if the error persists, contact us.
                            </div>                            
                        </div>
                    </motion.div>                    

                    <motion.div class="cardSection signed expand-x flex-col-start-start _8" v-if="(stage===RegisterStages.SPRING_2FA||stage===RegisterStages.SUMMER_2FA) && signUpSuccess && !loadingSignup && !signupData.show_recovery" :transition="{visualDuration: 0.3}" :animate="{opacity: (stage===RegisterStages.SPRING_2FA||RegisterStages.SUMMER_2FA) && signUpSuccess ? 1 : 0}">
                        <div class="flex-col-start-start">
                            <div class="smalltext font-s force-mako qrtext">
                                We use 2FA to limit account sharing. <br id="largeBreak"> Please use your authenticator app to trust this device.
                            </div>
                        </div>
                        <div class="flex-row-center-center expand-x holdQr">
                            <div id="qrcode" class="qrcode relative" style="align-self: center;">
                                <canvas id="qrcode-canvas"></canvas>
                            </div>
                        </div>
                        <div class="expand-x pinHold">
                            <div>
                            <Label for="pin-input" class="font-s force-mako base-f">2fa code</Label>
                            <PinInputRoot 
                                id="pin-input"
                                class="PinInputRoot"
                                :otp="true"
                                :placeholder="'○'"
                                v-model="signupData.twofa_input"
                                @complete="finish_signup()"
                                ref="pinInputRef"
                            >
                                <PinInputInput
                                    v-for="(id, index) in 6"
                                    :key="id"
                                    :index="index"
                                    class="PinInputInput font-m"
                                >
                                </PinInputInput>
                            </PinInputRoot>
                            </div>
                        </div>
                        <div class="twofaFallback flex-col-start-center">
                            <button :class="{active: showManualTwofa}" @click="toggleManual()" class="toggleManual font-s force-mako base-f flex-row-start-center _6" style="text-align: center;">
                                <div class="base-ft">On mobile / QR not working?</div>
                                <svg data-testid="geist-icon" height="16" stroke-linejoin="round" viewBox="0 0 16 16" width="16" style="color: currentcolor;"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0607 5.49999L13.5303 6.03032L8.7071 10.8535C8.31658 11.2441 7.68341 11.2441 7.29289 10.8535L2.46966 6.03032L1.93933 5.49999L2.99999 4.43933L3.53032 4.96966L7.99999 9.43933L12.4697 4.96966L13 4.43933L14.0607 5.49999Z" fill="currentColor"></path></svg>
                            </button>
                            <transition name="dropdown">
                                <div class="flex-col-start-center" v-show="showManualTwofa" style="margin-top: 6px;">
                                    <span class="font-s force-mako base-f" style="text-align: center;">
                                        Copy and paste the code manually into authenticator.
                                    </span>                                
                                    <div class="flex-row-start-center _6">
                                        <span class="font-xs base-ft accentuate">{{ signupData.twofa_secret??'' }}</span>
                                        <button @click="clipManualTwofa()" class="clipBoard s-btn btn-background">
                                            <Icon color="#00a11b" v-show="manualCopied" icon="clarity:success-line"></Icon>
                                            <Icon v-show="!manualCopied" icon="tabler:copy"></Icon>
                                        </button>                                 
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div v-if="promoError" class="base-f font-s error-message expand-x flex-row-center-center">
                            Invalid code, wait for refresh and try again
                        </div>                                      
                    </motion.div>
                    
                    <motion.div class="cardSection signing expand-x flex-col-start-start _6" v-show="loadingSignup" :transition="{visualDuration: 0.3}" :animate="{opacity: loadingSignup ? 1 : 0}">
                        <div class="loader"></div>
                        <p class="base-ft force-mako font-m relative StepperTitle">{{ loadingSignupTitle }}</p>
                    </motion.div>
                    
                    <motion.div class="cardSection signing expand-x flex-col-start-start _6" v-show="signupData.show_recovery" :transition="{duration: 0.3}" :animate="{opacity: signupData.show_recovery ? 1 : 0}">
                        <div class="font-s force-mako" style="text-align: center;">
                            Recovery codes ensure that you will be able to recover
                            your account in the event that you lose access to your
                            2FA authentication method. Store them in a secure place
                            like a password manager, you will only see them once.
                        </div>
                        <button @click="clipRecoveryCodes()" class="clipBoard s-btn btn-background" style="margin-top: 12px;">
                            <Icon icon="tabler:copy"></Icon>
                            <span class="base-ft">{{ copyMessage }}</span>
                        </button>                        
                        <div class="flex-row-start-start _8">
                            <div v-for="(val, key) in signupData.recovery_codes" class="recovery_code" :key="key">
                                {{ val }}
                            </div>
                        </div>
                        <div class="expand-x flex-row-center-center _8" style="margin-top: 24px;">
                            <a id="m-flex" href="https://www.google.com/search?q=what+are+twofa+recovery+codes&oq=what+are+twofa+recovery+codes&gs_lcrp=EgZjaHJvbWUyCwgAEEUYChg5GKABMgcIARAhGI8CMgcIAhAhGI8CMgcIAxAhGI8C0gEINTMxMGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8" rel="noopener" target="_blank" class="s-btn btn-background" aria-label="external article about recovery codes"><span class="base-ft">About recovery codes</span></a>
                            <button @click="acceptRecoveryCodes()" class="s-btn btn-foreground" aria-label="confirm that recovery codes are saved"><span class="base-ft">I've stored my codes</span></button>
                        </div>                                                                        
                    </motion.div>
                                        
                    <motion.div class="cardSection signed expand-x flex-col-start-start _6" v-if="stage===RegisterStages.SPRING_PAY||RegisterStages.SUMMER_PAY && !(stage===RegisterStages.PAY_SUCCEDED||stage===RegisterStages.PAY_FAILED)" :transition="{visualDuration: 0.3}" :animate="{opacity: step===3 ? 1 : 0}">
                        <div class="checkoutItem">
                            <div class="ico">
                                <svg v-if="stage===RegisterStages.SPRING_PAY||signupData.account_type===AccountType.SPRING" version="1.0" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                                    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                    fill="#000000" stroke="none">
                                    <path d="M2334 4898 c-562 -571 -991 -1143 -1244 -1663 -250 -513 -320 -929
                                    -228 -1355 146 -676 690 -1208 1371 -1339 59 -12 124 -21 143 -21 l34 0 0
                                    -260 0 -260 150 0 150 0 0 259 0 258 63 6 c211 20 517 127 701 245 602 388
                                    918 1076 801 1748 -105 602 -528 1332 -1214 2094 -102 114 -492 510 -502 510
                                    -3 0 -104 -100 -225 -222z m76 -980 l0 -623 -287 287 -287 287 56 73 c141 183
                                    497 598 513 598 3 0 5 -280 5 -622z m475 437 c129 -146 395 -472 395 -484 0
                                    -3 -128 -134 -285 -291 l-285 -285 0 624 0 624 21 -19 c12 -10 81 -86 154
                                    -169z m-475 -1985 l0 -505 -556 556 -556 556 55 114 c62 128 165 310 251 443
                                    l58 89 374 -374 374 -374 0 -505z m1178 1047 c50 -84 123 -217 163 -296 l72
                                    -143 -557 -557 -556 -556 0 505 0 505 373 373 372 373 21 -26 c11 -14 61 -94
                                    112 -178z m-1786 -1364 l608 -608 0 -312 0 -313 -25 0 c-46 0 -177 31 -282 65
                                    -212 71 -392 183 -558 350 -210 209 -333 438 -396 735 -26 124 -32 382 -10
                                    490 24 126 43 200 49 200 4 0 280 -273 614 -607z m2152 540 c35 -159 40 -205
                                    40 -358 -1 -227 -40 -401 -135 -604 -129 -275 -380 -531 -657 -670 -133 -67
                                    -379 -141 -467 -141 l-25 0 0 312 0 313 607 607 c335 335 611 608 615 608 3 0
                                    13 -30 22 -67z"/>
                                    </g>
                                </svg> 
                                <svg v-if="stage===RegisterStages.SUMMER_PAY||signupData.account_type===AccountType.SUMMER" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30"><path fill="#000" d="M4.37 14.62c0-.24.08-.45.25-.62c.17-.16.38-.24.6-.24h2.04c.23 0 .42.08.58.25c.15.17.23.37.23.61s-.07.44-.22.61s-.35.25-.58.25H5.23c-.23 0-.43-.08-.6-.25a.83.83 0 0 1-.26-.61m2.86 6.93c0-.23.08-.43.23-.61l1.47-1.43c.15-.16.35-.23.59-.23s.44.08.6.23s.24.34.24.57c0 .24-.08.46-.24.64L8.7 22.14q-.615.48-1.23 0a.8.8 0 0 1-.24-.59m0-13.84c0-.23.08-.43.23-.61c.2-.17.41-.25.64-.25c.22 0 .42.08.59.24l1.43 1.47c.16.15.24.35.24.59q0 .36-.24.6c-.24.24-.36.24-.6.24s-.44-.08-.59-.24L7.47 8.32a.84.84 0 0 1-.24-.61m2.55 6.91c0-.93.23-1.8.7-2.6s1.1-1.44 1.91-1.91s1.67-.7 2.6-.7c.7 0 1.37.14 2.02.42c.64.28 1.2.65 1.66 1.12c.47.47.84 1.02 1.11 1.66s.41 1.32.41 2.02c0 .94-.23 1.81-.7 2.61s-1.1 1.43-1.9 1.9s-1.67.7-2.61.7s-1.81-.23-2.61-.7s-1.43-1.1-1.9-1.9c-.45-.81-.69-1.68-.69-2.62m1.7 0c0 .98.34 1.81 1.03 2.5c.68.69 1.51 1.04 2.49 1.04s1.81-.35 2.5-1.04s1.04-1.52 1.04-2.5c0-.96-.35-1.78-1.04-2.47c-.69-.68-1.52-1.02-2.5-1.02c-.97 0-1.8.34-2.48 1.02c-.7.69-1.04 1.51-1.04 2.47m2.66 7.78c0-.24.08-.44.25-.6s.37-.24.6-.24c.24 0 .45.08.61.24s.24.36.24.6v1.99c0 .24-.08.45-.25.62s-.37.25-.6.25s-.44-.08-.6-.25a.85.85 0 0 1-.25-.62zm0-15.5V4.86c0-.23.08-.43.25-.6S14.76 4 15 4s.43.08.6.25s.25.37.25.6V6.9c0 .23-.08.42-.25.58s-.37.23-.6.23s-.44-.08-.6-.23s-.26-.35-.26-.58m5.52 13.18c0-.23.08-.42.23-.56c.15-.16.34-.23.56-.23c.24 0 .44.08.6.23l1.46 1.43c.16.17.24.38.24.61s-.08.43-.24.59q-.6.465-1.2 0l-1.42-1.42a.97.97 0 0 1-.23-.65m0-10.92c0-.25.08-.45.23-.59l1.42-1.47a.84.84 0 0 1 .59-.24c.24 0 .44.08.6.25c.17.17.25.37.25.6c0 .25-.08.46-.24.62l-1.46 1.43q-.27.24-.6.24c-.23 0-.41-.08-.56-.24s-.23-.36-.23-.6m2.26 5.46c0-.24.08-.44.24-.62q.24-.24.57-.24h2.02c.23 0 .43.09.6.26s.26.37.26.6s-.09.43-.26.6s-.37.25-.6.25h-2.02c-.23 0-.43-.08-.58-.25s-.23-.36-.23-.6" stroke-width="1" stroke="#000"/></svg>
                            </div>
                            <div class="item">
                                <p class="base-ft force-mako font-m relative StepperTitle" v-if="signupData.account_type === 'spring'">doored <i>{{ billablePrice === 29 ? 'S' + signupData.account_type.split('s')[1] : 'Build ' + signupData.account_type }}</i></p>
                                <p class="base-ft force-mako font-m relative StepperTitle" v-else-if="signupData.account_type === 'summer'">doored <i>{{ billablePrice === 29 ? 'S' + signupData.account_type.split('s')[1] + '/Grad' : 'Build ' + signupData.account_type + '/grad' }}</i></p>
                                <span class="font-s base-ft force-mako relative">
                                    {{ numberOfFirms }} — 6 months access
                                </span>
                            </div>
                            <div class="holdamount">
                                <div class="amount font-m base-ft relative">£{{ billablePrice }}</div>
                            </div>
                        </div>

                        <div class="promo" v-if="signupData.permission != AccountPermissionType.BUILD">
                            <div class="inputRow promotion" :class="{invalid: promoError}">
                                <span class="prefix force-mako font-s base-f expand-x">Promo code</span>
                                <input type="text" class="emailInput base-f font-m expand-x relative" v-model="promo_code" style="text-transform: uppercase;">
                                <div class="check" v-if="(acceptedPromoCode || promoError) && !checkingPromoCode">
                                    <Icon v-if="acceptedPromoCode && !checkingPromoCode" icon="clarity:success-line" class="checkIcon success"></Icon>  
                                    <Icon v-if="!acceptedPromoCode && !checkingPromoCode" icon="material-symbols:error-outline" class="checkIcon error"></Icon>
                                </div>
                            </div>
                            <button @click="checkPromoCode()" class="action s-btn btn-background">
                                <span class="base-ft" v-if="!checkingPromoCode">Apply</span>
                                <div v-if="checkingPromoCode" class="loader input"></div>
                            </button>
                        </div>                        

                        <div class="amountRow">
                            <p class="base-ft force-mako font-m relative StepperTitle">Total due</p>
                            <div class="holdamount">
                                <span class="amount font-m base-ft relative">
                                    <div class="strike" v-if="acceptedPromoCode"></div>
                                    £{{ billablePrice }}
                                </span>
                                &nbsp;
                                <span v-if="acceptedPromoCode" class="amount font-m base-ft fade" style="color: var(--candy);">
                                    £{{ Math.round((billablePrice * (1 - applied_discount)) * 100) / 100 }}
                                </span>
                            </div>
                        </div>

                       <div v-if="signupData.permission == AccountPermissionType.BUILD" style="width: 100%; display: flex; position: relative; justify-content: start; z-index: 999;">
                        <TooltipRoot @update:open="handleToolTipOpenPromoQuestion">
                            <TooltipTrigger as="p" class="base-f force-mako font-m relative StepperTitle promo-question" style="cursor: default;">
                                Where's my promo code? 
                            </TooltipTrigger>
                            <TooltipPortal>
                                <AnimatePresence>
                                <TooltipContent v-if="showPromoQuestion" :side-offset="5" side="top" :align="'start'" style="z-index: 999 !important;">
                                    <motion.div class="tooltipContent" :initial="{ opacity: 0, scale: 0.98 }" :animate="{ opacity: 1, scale: 1 }" :exit="{ opacity: 0, scale: 0.98 }">
                                        Promos are not offered for custom packs
                                        <TooltipArrow class="base-ft force-mako font-m relative tooltipArrow StepperTitle" style="fill: #fff !important;" :width="8"></TooltipArrow>
                                    </motion.div>
                                </TooltipContent>
                                </AnimatePresence>
                            </TooltipPortal>
                        </TooltipRoot>                
                        </div>                        
                    </motion.div>
                    
                    <motion.div id="s-flex" class="cardSection mobilePayment expand-x" v-if="step===3 && isMobileUser" :transition="{visualDuration: 0.3}" :animate="{opacity: step===3 ? 1 : 0}">
                        <PaymentFormMobile :key="applied_promo + 'mobile'" @tried-with-free="console.log('tried with free')" :promo_applied="acceptedPromoCode"></PaymentFormMobile>                
                    </motion.div>                      
                    
                    <motion.div 
                        class="cardSection expand-x flex-col-start-start _6" 
                        v-if="(stage===RegisterStages.PAY_SUCCEDED||stage===RegisterStages.PAY_FAILED) && !loadingSignup"
                        :transition="{visualDuration: 0.3}" 
                        :animate="{opacity: (stage===RegisterStages.PAY_SUCCEDED||stage===RegisterStages.PAY_FAILED) && !loadingSignup ? 1 : 0}"
                    >
                        <CheckPayment @auto-login="tryLogin()" @newPaymentTitle="val => paymentStatus=val" @retryPayment="console.log('RETRY')"></CheckPayment>
                    </motion.div>
  -->               </div>
            </div>

            <footer class="expand-x flex-col-start-center _8">
                <div class="warning base-ft relative font-s force-mako">
                    <Icon id="m-block" icon="material-symbols:info-outline-rounded" width="18" height="18"></Icon>
                    <span>By signing up you agree to our <a class="interaction_transition" :href="staticURL('terms')">Terms of service</a></span>
                </div>
                <div class="new flex-row-center-center _6 base-ft force-mako relative font-s">
                    Already have an account<span>—</span><span @click="router.push('/login')" class="accentuate interaction_transition" id="sign">Login</span>
                </div>                                
            </footer>
        </section>

        <section class="flex-row-center-center s2" id="m-flex">
            <div class="holdform relative" v-if="step===3 && !isMobileUser">
                <PaymentForm :key="applied_promo" @tried-with-free="console.log('tried with free')" :promo_applied="acceptedPromoCode" v-if="step===3"></PaymentForm>
            </div>

            <div class="holdform relative" v-if="step!=3 && stage != RegisterStages.SPRING_BUILD && stage != RegisterStages.SUMMER_BUILD">
                <div class="bigText base-f embrace-heavy">
                    <div class="stars"></div>
                    doored — the door into finance
                </div>                
            </div>

            <div class="holdform build relative" v-if="stage === RegisterStages.SPRING_BUILD || stage === RegisterStages.SUMMER_BUILD">
                <BuildComp :is-graduating="signupData.is_graduating" @updated-selection="val => pack=val"></BuildComp>
            </div>
        </section>
        </TooltipProvider>
    </main>
</template>

<script setup lang="ts">
import PaymentForm from './PaymentForm.vue';
import PaymentFormMobile from './PaymentFormMobile.vue';
import CheckPayment from './CheckPayment.vue';
import BuildComp from './BuildComp.vue';
import { computed, ref, reactive, watch, onMounted, nextTick } from 'vue';
import type { ComponentPublicInstance } from 'vue';
import router from '@/router';
import { AxiosError } from 'axios';
import axios from 'axios';
import companyLogoLight from '@/assets/doored99.svg';

import { staticURL, RegisterStages, RegisterRedirects, backendURL, LoginData, clearRegisterCache, loginRequest, signWithGoogle } from '@/store/state';
import { AccountPermissionType, RegisterStageData } from '@/store/state';
import { useUserStore, AccountType } from '@/store/userData';

import { Icon } from '@iconify/vue';
import QRCode from 'qrcode';
import { AnimatePresence, motion } from 'motion-v';
import { StepperIndicator, StepperItem, StepperRoot, StepperTitle, StepperTrigger, TooltipProvider, TooltipRoot, TooltipTrigger, TooltipPortal, TooltipContent, TooltipArrow } from 'reka-ui';
import { Label, PinInputInput, PinInputRoot } from 'reka-ui';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-vue-v3';
import { useCompaniesStore } from '@/store/companyStatic';

const {data, error, isLoading, getData} = useVisitorData({extendedResult: true}, {immediate: false});

/*PROPS AND EMITS*/
const props = defineProps<{stage: RegisterStages, redirect: RegisterRedirects, stageData: RegisterStageData }>();
const emit = defineEmits<{
    (e: 'nextStage', to: RegisterStages): void
    (e: 'previousStage'): void
    (e: 'signed', account_type: AccountType) : void
    (e: 'verified_twofa', account_type: AccountType) : void
}>();

/*EXPLICIT STAGE CONTROL*/
const chooseStage = (to: RegisterStages) => {
    emit('nextStage', to)
}
const goBack = () => {
    if (props.stage === RegisterStages.SPRING_PACKS) {
        signupData.account_type = AccountType.ORPHAN
    } else if (props.stage === RegisterStages.SUMMER_PACKS) {
        signupData.account_type = AccountType.ORPHAN
    }
    emit('previousStage')
}
const step = computed(() => {
    switch (props.stage) {
        case 'internship_options':
            return 1;
        case 'spring_packs':
            return 1;
        case 'summer_packs':
            return 1;
        case 'spring_build':
            return 1;
        case 'summer_build':
            return 1;
        case 'spring_form':
            return 2;
        case 'summer_form':
            return 2;
        case 'spring_2fa':
            return 2;
        case 'summer_2fa':
            return 2;
        case 'spring_pay':
            return 3;
        case 'summer_pay':
            return 3;
        case 'pack_upgrade':
            return 3;
        case 'build_upgrade':
            return 1;
    }
    return 1;
})
const steps = [
    {
        step: 1,
        title: 'Choose',
        icon: 'radix-icons:home'
    },
    {
        step: 2,
        title: 'Sign up',
        icon: 'line-md:account-add'
    },
    {
        step: 3,
        title: 'Pay',
        icon: 'healthicons:credit-card-outline'
    },        
]

/*UI Helpers*/
const handleBuildReady = () => {
    if (pack.value.length < 1) return;
    if (useUserStore().user) {
        if (signupData.is_graduating) {
            emit('verified_twofa', AccountType.SUMMER);
        } else {
            emit('verified_twofa', useUserStore().user?.account_type as AccountType);
        }
    } else {
        chooseStage(props.stage===RegisterStages.SPRING_BUILD ? RegisterStages.SPRING_FORM : RegisterStages.SUMMER_FORM)
    }
    signupData.permission = AccountPermissionType.BUILD;
    localStorage.setItem('cached_pack', JSON.stringify(pack.value));
}

const focusInputs = ref<Record<string, HTMLInputElement>>({});
const showPromoQuestion = ref<boolean>(false);
//
function handleToolTipOpenPromoQuestion(value: boolean) {
  showPromoQuestion.value = value;
}
const showConflictingUsername = ref<boolean>(false);
const handleConflictingUsername = (value: boolean) => {
    showConflictingUsername.value = value;
}
const showInvalidPasswordTool = ref<boolean>(false);
const handleInvalidPasswordTool = (value: boolean) => {
    showInvalidPasswordTool.value = value;
}
const showEmailError = ref<boolean>(false);
const handleEmailErrorToolTip = (value: boolean) => {
    showEmailError.value = value;
}
/*DATA STRUCTS*/
const paymentStatus = ref<string>('');
interface UserSignupData {
    username: string
    email: string
    password: string
    account_type: AccountType
    fingerprint: string
    permission: AccountPermissionType
    twofa_uri: string
    twofa_secret: string
    twofa_input: string[]
    recovery_codes: string[]
    show_recovery: boolean
    is_graduating: boolean
}
const signupData = reactive<UserSignupData>({
    username: '',
    email: '',
    password: '',
    account_type: AccountType.ORPHAN,
    fingerprint: '',
    permission: AccountPermissionType.FREE,
    twofa_uri: '',
    twofa_secret: '',
    twofa_input: [],
    recovery_codes: [],
    show_recovery: false,
    is_graduating: false,
})

/*INPUT VALIDATION*/
function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
function isAlphanumeric(str: string) {
  return /^[a-zA-Z0-9]+$/.test(str)
}
let emailValidationTimer: number;
async function validateEmail() {
    checkingEmail.value = true;
    clearTimeout(emailValidationTimer);
    emailValidationTimer = setTimeout(async () => {
        if (isValidEmail(signupData.email)) {
            try {
                await axios.get(backendURL(`auth/check-email-conflict?email=${signupData.email}`))
                validEmail.value = true;
            } catch (error) {
                console.log(error)
                emailMessage.value = "Email already in use"
                validEmail.value = false;
                handleEmailErrorToolTip(true);
            }
        } else {
            emailMessage.value = "This is not a valid email"
            validEmail.value = false;
            handleEmailErrorToolTip(true);
        }
        checkingEmail.value = false;
        emailChecked.value = true;
    }, 600)
}
let usernameValidationTimer: number;
async function validateUsername() {
    checkingUsername.value = true;
    clearTimeout(usernameValidationTimer)
    usernameValidationTimer = setTimeout(async () => {
        if (signupData.username.length >= 4 && signupData.username.length <= 14 && isAlphanumeric(signupData.username)) {
            try {
                await axios.get(backendURL(`auth/check-username-conflict?username=${signupData.username}`))
                validUsername.value = true;
            } catch (error) {
                console.log(error)
                usernameMessage.value = "Username already in use"
                validUsername.value = false;
                handleConflictingUsername(true);
            }            
        } else {
            usernameMessage.value = "Choose an alphanumeric with 4-14 characters"
            validUsername.value = false;
            handleConflictingUsername(true);
        }
        checkingUsername.value = false;
        usernameChecked.value = true;
    }, 600)
}
let passwordValidationTimer: number;
function validatePassword() {
    checkingPassword.value = true;
    clearTimeout(passwordValidationTimer)
    passwordValidationTimer = setTimeout(() => {
        if (signupData.password.length >= 8) {
            validPassword.value = true;
        } else {
            validPassword.value = false;
            handleInvalidPasswordTool(true);
        }
        checkingPassword.value = false;
        passwordChecked.value = true;
    }, 600)
}

const loadingSignup = ref<boolean>(false);
const loadingSignupTitle = ref<string>('');
const signUpSuccess = ref<boolean>(false);

const validEmail = ref<boolean>(true);
const checkingEmail = ref<boolean>(false);
const emailChecked = ref<boolean>(false);
const emailMessage = ref<string>("This is not a valid email")

const validUsername = ref<boolean>(true);
const checkingUsername = ref<boolean>(false);
const usernameChecked = ref<boolean>(false);
const usernameMessage = ref<string>("Choose an alphanumeric with 4-14 characters")

const checkingPassword = ref<boolean>(false);
const passwordChecked = ref<boolean>(false);
const validPassword = ref<boolean>(true);

const userStore = useUserStore();
const showEmailInputValidationFailure = ref<boolean>(false);

const validInputs = computed(() => {
    return (emailChecked.value && validEmail.value && usernameChecked.value && validUsername.value && passwordChecked.value && validPassword.value)
})

const emailEmpty = computed(() => {
    return signupData.email.length===0 ? true : false;
})
const usernameEmpty = computed(() => {
    return signupData.username.length===0 ? true : false;
})
const passwordEmpty = computed(() => {
    return signupData.password.length===0 ? true : false;
})

/*SIGNUP FUNCS*/
async function initiate_emailSignup() {
    if (validInputs.value) {
        loadingSignupTitle.value = 'Validating inputs';
        loadingSignup.value = true;

        await getData();
        signupData.fingerprint = data.value?.visitorId ?? '';

        try {
            const res = await axios.post(backendURL('auth/start-signup/email'), {...signupData}, {withCredentials: true})            
            localStorage.setItem('jwt', res.data.jwt)
            signupData.twofa_uri = res.data.uri;
            signupData.twofa_secret = res.data.secret;
            await new Promise(resolve => setTimeout(resolve, 1400))
            emit('signed', signupData.account_type)

            loadingSignup.value = false;
            signUpSuccess.value = true;

        } catch (error: AxiosError|unknown) {
            console.log(error)
            loadingSignup.value = false;
            clearRegisterCache();
            showEmailInputValidationFailure.value = true;
        }
    }
}

async function finish_signup() {
    loadingSignupTitle.value = 'Signing up'
    loadingSignup.value = true;
    const jwt = localStorage.getItem('jwt')
    if (!jwt||jwt==='') return;
    try {
        const endpoint = signupData.password != '' ? 'email' : 'google';
        const res = await fetch(backendURL(`auth/finish-signup/${endpoint}`), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`,
            },
            body: JSON.stringify({otp: signupData.twofa_input.join('')})
        })

        if (res.ok) {
            promoError.value = false;
            const res_data = await res.json()
            signupData.recovery_codes = res_data.recovery_codes;
            signupData.show_recovery = true;
        } else {
            const errorData = await res.json();
            console.log(errorData)
            console.log(errorData.details)
            console.log(errorData.message)
            if (errorData.message === 'Token has expired') {
                await localStorage.clear();
                window.location.href = '?retry=timeout'
            } else {
                signupData.twofa_input = [];
                promoError.value = true;
                const cached_uri = localStorage.getItem('twofa_uri')??''
                loadingSignup.value = false;
                await nextTick();
                generateQR(cached_uri);
            }
        }
    } 
    catch (error) {
        console.error(error);
    }
    finally {
        loadingSignup.value = false;
    }
}

const acceptRecoveryCodes = async () => {
    signupData.show_recovery = false;
    /**/
    const seoSign = localStorage.getItem('seoSignature');
    if (seoSign) {
        try {
            const res = await fetch(backendURL('auth/validate-seo'), {
                method: 'POST',
                credentials: 'include',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({'email': signupData.email, 'signature': seoSign}),
            })
            if (res.ok) {
                await tryLogin();
            }
        } catch (error) {
            console.log("failed seo validate"); 
        }
        /**/
    } else {
        if (signupData.permission === AccountPermissionType.FREE) {
            await tryLogin();
        } else {
            emit('verified_twofa', signupData.account_type);
        }
    }
}

const copyMessage = ref<string>('copy all')
const clipRecoveryCodes = async() => {
    const formattedCodes = signupData.recovery_codes.join('\n');
    try {
        await navigator.clipboard.writeText(formattedCodes)
        copyMessage.value = 'copied'
    } catch (err) {
        copyMessage.value = "could not copy"
    }
}

const manualCopied = ref<boolean>(false);
const clipManualTwofa = async() => {
    const code = signupData.twofa_secret;
    try {
        await navigator.clipboard.writeText(code);
        manualCopied.value = true;
    } catch (err) {
        manualCopied.value = false;
    }
}

const showManualTwofa = ref<boolean>(false);
const toggleManual = () => {
    showManualTwofa.value = !showManualTwofa.value;
}

const allowedOrigins = [
    'https://dev.doored.uk:8080',
    'https://doored.uk',
    'https://doored.eu',
    'https://doored.app',
]
/***/
async function googleSignup() {
    loadingSignup.value = true;
    const listenGoogle = async (event: MessageEvent) => {
        if (!allowedOrigins.includes(event.origin)) return;

        let shouldRemoveListener = false;

        if (event.data && event.data.type === 'oauth-success') {
            shouldRemoveListener = true;
            const { jwt, uri, secret, email } = event.data.payload;
            localStorage.setItem('jwt', jwt)
            signupData.twofa_uri = uri;
            signupData.twofa_secret = secret;
            signupData.email = email;
            await new Promise(resolve => setTimeout(resolve, 1400))
            emit('signed', signupData.account_type)
            loadingSignup.value = false;
            signUpSuccess.value = true;
        } 
        
        else if (event.data && event.data.type === 'oauth-fail') {
            shouldRemoveListener = true;
            loadingSignup.value = false;
            clearRegisterCache();
            const obj = event.data.payload;
            console.log(obj)
        }

        if (shouldRemoveListener) {
            window.removeEventListener('message', listenGoogle, false);
        }
    };
    
    window.addEventListener('message', listenGoogle, false);

    await getData();
    signupData.fingerprint = data.value?.visitorId ?? '';
    const baseUrl = `${import.meta.env.VITE_API_BASE}/auth/signup/google`
    const redirectUrl = `${baseUrl}?account_type=${encodeURIComponent(signupData.account_type)}&fingerprint=${encodeURIComponent(signupData.fingerprint)}`;
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=800,height=500,left=230,top=140`;
    open(redirectUrl, 'OAuth', params)
}

const clearCacheAndPushApp = () => {
    clearRegisterCache();
    router.push('/')
}

async function tryLogin() {
    console.log("trying login")
    const cachedStage = localStorage.getItem('current_stage')
    if (cachedStage === RegisterStages.PACK_UPGRADE || useUserStore().isLoggedIn) {
        clearCacheAndPushApp()
        return;
    }
    loadingSignupTitle.value = "Signing in"
    loadingSignup.value = true;
    await nextTick();
    if (signupData.email != '' && signupData.password != '') {
        const login_data: LoginData = {email: signupData.email, password: signupData.password, remember: true, fingerprint: signupData.fingerprint}
        try {
            const res = await loginRequest(login_data)
            if (res.ok) {
                const data = await res.json()
                userStore.setUser(data.user_data)
                userStore.hydrateState();
                await new Promise(resolve => setTimeout(resolve, 2000))
                clearCacheAndPushApp()
            }
        } catch (error) {
            clearCacheAndPushApp()
        } 
    } 
    
    else if (signupData.email != '' && !(signupData.password||signupData.password!=='') ) {
        console.log("TRYING GOOGLE AUTO SIGN IN")
        await signWithGoogle(true);
        loadingSignup.value = false;
    }

    else {
        console.log("FAILED TO CATCH AUTO SIGN")
        clearRegisterCache()
        router.push('/login')
    }
}

/*PROMO CODE*/
const promo_code = ref<string|null>(null);
const applied_discount = ref<number>(0);
const checkingPromoCode = ref<boolean>(false);
const acceptedPromoCode = ref<boolean>(false);
const promoError = ref<boolean>(false);
const applied_promo = ref<string>('');

async function checkPromoCode() {
    if (signupData.permission == AccountPermissionType.BUILD) return;
    if (promo_code.value) {
        acceptedPromoCode.value = false;
        promoError.value = false;
        checkingPromoCode.value = true;

        try {
            const res = await fetch(
                backendURL('payments/verify-promo-code'),
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({'promo_code': promo_code.value}), 
                }
            )
            if (!res.ok) {
                throw new Error(`${res.status}`)
            }
            const data = await res.json()
            applied_discount.value = data.discount;
            acceptedPromoCode.value = true;
            checkingPromoCode.value = false;
            applied_promo.value = promo_code.value;
            await localStorage.setItem('applied_promo_code', JSON.stringify(true));
            await localStorage.setItem('promo_code', promo_code.value);
            await localStorage.setItem('discount_pct', JSON.stringify(applied_discount.value));
        }
        catch (error) {
            console.error(error)
            promoError.value = true;
            acceptedPromoCode.value = false;
            checkingPromoCode.value = false;
        }
    }
}

const pack = ref<number[]>([]);
const billablePrice = computed(() => {
    if (signupData.permission === AccountPermissionType.BUILD) {
        return pack.value.length * 12;
    } else {
        return 29;
    }
})

/********/
const isMobileUser = ref<boolean>(false);
const cacheStage = (stage: RegisterStages) => {
    localStorage.setItem('current_stage', stage)
}
const cacheSignupData = () => {
    for (const [key, val] of Object.entries(signupData)) {
        if (key === 'show_recovery' || key === 'recovery_codes') {
            localStorage.setItem(key, JSON.stringify(val))
        } else {
            localStorage.setItem(key, String(val));
        }
    }
}
const hydrateSignupData = () => {
    for (const key of Object.keys(signupData) as Array<keyof UserSignupData>) {
        const val = localStorage.getItem(key)
        if (val != null) {
            if (key === 'account_type') {
                signupData.account_type = val as AccountType;
            }
            else if (key === 'permission') {
                signupData.permission = val as AccountPermissionType
            }
            else if (key === 'show_recovery' || key === 'recovery_codes' || key === 'is_graduating') {
                signupData[key] = JSON.parse(val)
            }
            else {
                signupData[key] = val;
            }
        }
    }
}
const hydratePack = () => {
    const cached = localStorage.getItem('cached_pack')
    if (cached) pack.value = JSON.parse(cached)
}
const hydratePromo = () => {
    const cached = localStorage.getItem('applied_promo_code');
    const code = localStorage.getItem('promo_code');
    const pct = localStorage.getItem('discount_pct');
    if (cached && code && pct) {
        acceptedPromoCode.value = JSON.parse(cached);
        promo_code.value = code;
        applied_discount.value = parseFloat(pct);
    } 
}

/*STAGE WATCHING, CACHING, HYDRATION*/
watch(signupData, () => {
    cacheSignupData();
})

watch(props, async (newVal) => {
    switch (newVal.stage) {
        case RegisterStages.OPTIONS:
            cacheStage(RegisterStages.OPTIONS)
            signupData.account_type = AccountType.ORPHAN;
            break;
        case RegisterStages.SPRING_PACKS:
            cacheStage(RegisterStages.SPRING_PACKS)
            signupData.account_type = AccountType.SPRING
            break;
        case RegisterStages.SPRING_BUILD:
            cacheStage(RegisterStages.SPRING_BUILD)
            signupData.permission = AccountPermissionType.BUILD;
            signupData.account_type = AccountType.SPRING;
            break;
        case RegisterStages.SPRING_FORM:
            // signupData.account_type = AccountType.SPRING;
            localStorage.setItem("account_type", AccountType.SPRING);
            cacheStage(RegisterStages.SPRING_FORM);
            hydratePack();

            if (newVal.redirect === RegisterRedirects.BuiltSpring) {
                signupData.permission = AccountPermissionType.BUILD;
            } else if (newVal.redirect === RegisterRedirects.ChoseSpringPack) {
                signupData.permission = AccountPermissionType.PREPPACK;
            }

            {
                // inefficient, but test
                const query = new URLSearchParams(window.location.search);
                const seoParam = decodeURIComponent(query.get("seo-signature") as string);
                if (seoParam !== "null") {
                    signupData.permission = AccountPermissionType.FREE;
                    localStorage.setItem("seoSignature", seoParam);
                }
            }

            break;
        case RegisterStages.SPRING_2FA:
            cacheStage(RegisterStages.SPRING_2FA)
            signUpSuccess.value = true;
            await nextTick();
            generateQR(signupData.twofa_uri)
            break;
        case RegisterStages.SPRING_PAY:
            cacheStage(RegisterStages.SPRING_PAY)
            hydratePack();
            hydratePromo();
            signUpSuccess.value = true;
            break;            
        case RegisterStages.SUMMER_PACKS:
            cacheStage(RegisterStages.SUMMER_PACKS)
            signupData.account_type = AccountType.SUMMER;
            break;
        case RegisterStages.SUMMER_BUILD:
            cacheStage(RegisterStages.SUMMER_BUILD)
            signupData.account_type = AccountType.SUMMER;
            signupData.permission = AccountPermissionType.BUILD;
            break;
        case RegisterStages.SUMMER_FORM:
            // signupData.account_type = AccountType.SUMMER;
            localStorage.setItem("account_type", AccountType.SUMMER);
            cacheStage(RegisterStages.SUMMER_FORM)
            if (newVal.redirect === RegisterRedirects.BuiltSummer) {
                signupData.permission = AccountPermissionType.BUILD;
            } else if (newVal.redirect === RegisterRedirects.ChoseSummerPack) {
                signupData.permission = AccountPermissionType.PREPPACK
            }
            
            // {
            //     // inefficient, but test
            //     const query = new URLSearchParams(window.location.search);
            //     const seoParam = decodeURIComponent(query.get("seo-signature") as string);
            //     if (seoParam !== "null") {
            //         signupData.permission = AccountPermissionType.FREE;
            //         localStorage.setItem("seoSignature", seoParam);
            //     }
            // }            
            break;
        case RegisterStages.SUMMER_2FA:
            cacheStage(RegisterStages.SUMMER_2FA)
            signUpSuccess.value = true;
            await nextTick();
            generateQR(signupData.twofa_uri)
            break;
        case RegisterStages.SUMMER_PAY:
            cacheStage(RegisterStages.SUMMER_PAY)
            hydratePack();
            hydratePromo();
            signUpSuccess.value = true;
            break;
        case RegisterStages.PACK_UPGRADE:
            signupData.permission = AccountPermissionType.PREPPACK;
            signupData.account_type = userStore.user?.account_type as AccountType?? localStorage.getItem('account_type')??'';
            signupData.email = userStore.user?.email?? localStorage.getItem('email')??'';
            cacheSignupData();
            cacheStage(RegisterStages.PACK_UPGRADE);
            break;
        case RegisterStages.BUILD_UPGRADE:
            if (useUserStore().user) {
                signupData.email = useUserStore().user?.email??'';
                signupData.account_type = useUserStore().user?.account_type as AccountType;
                cacheSignupData();

                if (signupData.account_type == AccountType.SPRING) {
                    emit('nextStage', RegisterStages.SPRING_BUILD);
                } else {
                    emit('nextStage', RegisterStages.SUMMER_BUILD);
                }

            } else {
                router.push("/login")
            }
            break;
        case RegisterStages.BUILD_GRADUATE:
            if (!useUserStore().user) {
                router.push("/login")
            } else if (useUserStore().user != null) {
                signupData.email = useUserStore().user?.email??'';
                signupData.account_type = AccountType.SUMMER;
                signupData.is_graduating = true;
                cacheSignupData();
                emit('nextStage', RegisterStages.SUMMER_BUILD);
            }
            break;
        case RegisterStages.PACK_GRADUATE:
            if (!useUserStore().user) {
                router.push("/login")
            } else if (useUserStore().user != null) {
                signupData.email = useUserStore().user?.email??'';
                signupData.account_type = AccountType.SUMMER;
                signupData.is_graduating = true;
                signupData.permission = AccountPermissionType.PREPPACK;
                cacheSignupData();
                emit('nextStage', RegisterStages.SUMMER_PAY);
            }
            break;            
    }
    hydrateSignupData();
})

const pinInputRef = ref<ComponentPublicInstance>();
watch(pinInputRef, async(newVal) => {
    if (newVal) {
        const rootEl = newVal.$el;
        const firstInput = rootEl.querySelector('.PinInputInput');
        await nextTick();
        firstInput.focus();                
    }
})

function generateQR(uri: string) {
    const canvas = document.getElementById('qrcode-canvas') as HTMLCanvasElement;
    if (!canvas) {
        console.error("Canvas not found!");
        return;
    }
    QRCode.toCanvas(canvas, uri, { width: 140, color: {dark: '#333333', light: "#fafafa"}, errorCorrectionLevel: 'H' }, (error: Error) => {
        if (error) console.error(error);
        else console.log('QR code generated!');
    });
}

const timeOutError = ref<boolean>(false);
onMounted(async () => {
    const timedOut = new URLSearchParams(window.location.search).get('retry')
    if (timedOut === 'timeout') {
        timeOutError.value = true;
    } else {
        timeOutError.value = false;
    }
    const cachedStage = localStorage.getItem('current_stage');
    if (cachedStage) {
        if (cachedStage === RegisterStages.SUMMER_FORM || cachedStage === RegisterStages.SPRING_FORM) {
            validateEmail();
            validateUsername();
            validatePassword();
        }
        if ((cachedStage===RegisterStages.SPRING_2FA||cachedStage===RegisterStages.SUMMER_2FA) && signupData.twofa_uri==='') {
            const cached_uri = localStorage.getItem('twofa_uri')??''
            await nextTick();
            generateQR(cached_uri)
        }
        emit('nextStage', cachedStage as RegisterStages)
    }    

    isMobileUser.value = window.matchMedia("(max-width: 1024px)").matches;
})

const firmNumber = computed(() => {
    let has_existing_pack = false;
    for (const [key, val] of Object.entries(useCompaniesStore().preferences)) {
        if (key != '1' && val.permitted) {
            has_existing_pack = true;
        }
    }
    if (has_existing_pack) {
        return pack.value.length;
    } else {
        return pack.value.length + 1;
    }
})
const buildFirmsNumberPrefix = computed(() => {
    switch (firmNumber.value) {
        case 0:
            return 'firms'
        case 1:
            return 'firm'
        default:
            return 'firms'
    }
})

const numberOfFirms = computed(() => {
    if (signupData.permission != AccountPermissionType.BUILD) {
        return '31 firms'
    } else {
        return `${firmNumber.value} ${buildFirmsNumberPrefix.value}`;
    }
})
</script>

<style scoped>
main {
    height: 100vh;
    width: 100vw;
    overflow-y: scroll !important;
    scrollbar-width: none;
    background-color: var(--bg);
}
section {
    width: 50%;
    height: auto;
    min-height: 100%;
    position: relative;
}
#s1 {
    background-color: var(--bg);
    display: grid;
    grid-template-rows: auto 1fr auto;
    width: 100%;
}
@media(min-width: 1024px) {
    #s1 {
        width: 50%;
    }
}
#largeBreak {
    display: none;
}
@media(min-width: 1800px) {
    #largeBreak {
        display: block;
    }
}
.s2 {
    min-height: max(200vh, fit-content);
}
.s2 .holdform {
    z-index: 2;
    width: 80%;
    max-height: 90%;
    min-height: fit-content;
    height: auto;
    z-index: 10;
}
@media(min-width: 1800px) {
    .s2 .holdform {
        max-width: 64%;
    }
}
.s2:has(.holdform.build) {
    padding: 48px 0 0 0 !important;
    align-items: start;
}
.holdform.build {
    width: 90% !important;
}
.s2:after {
    background: radial-gradient(rgb(255, 203, 87) 23%, rgba(255, 203, 87, 0) 67%, rgba(255, 203, 87, 0) 100%) 385px -24px, radial-gradient(var(--primary) 0%, rgba(169, 96, 238, 0) 60%, rgba(169, 96, 238, 0) 100%) -940px 290px, radial-gradient(#f044ae 10%, rgba(144, 224, 255, 0) 60%, rgba(144, 224, 255, 0) 100%) -120px 250px, radial-gradient(rgb(255, 51, 61) 40%, rgba(169, 96, 238, 0) 57%, rgba(169, 96, 238, 0) 100%) 495px -44px, radial-gradient(rgb(255, 51, 61) 30%, rgba(169, 96, 238, 0) 67%, rgba(169, 96, 238, 0) 100%) 122px -120px, radial-gradient(rgb(169, 96, 238) 10%, rgba(169, 96, 238, 0) 60%, rgba(169, 96, 238, 0) 100%) -420px 120px, radial-gradient(rgb(255, 51, 61) 15%, rgba(144, 224, 255, 0) 50%, rgba(144, 224, 255, 0) 100%) -620px 0px, radial-gradient(var(--dark-contrast) 25%, rgba(144, 224, 255, 0) 50%, rgba(144, 224, 255, 0) 100%) 520px -250px, rgb(169, 96, 238);
    background-image: radial-gradient(rgb(255, 203, 87) 23%, rgba(255, 203, 87, 0) 67%, rgba(255, 203, 87, 0) 100%), radial-gradient(#f044ae 0%, rgba(169, 96, 238, 0) 60%, rgba(169, 96, 238, 0) 100%), radial-gradient(#f044ae 10%, rgba(144, 224, 255, 0) 60%, rgba(144, 224, 255, 0) 100%), radial-gradient(#f044ae 40%, rgba(169, 96, 238, 0) 57%, rgba(169, 96, 238, 0) 100%), radial-gradient(#f044ae 30%, rgba(169, 96, 238, 0) 67%, rgba(169, 96, 238, 0) 100%), radial-gradient(rgb(169, 96, 238) 10%, rgba(169, 96, 238, 0) 60%, rgba(169, 96, 238, 0) 100%), radial-gradient(#f044ae 15%, rgba(144, 224, 255, 0) 50%, rgba(144, 224, 255, 0) 100%), radial-gradient(#f044ae 25%, rgba(144, 224, 255, 0) 50%, rgba(144, 224, 255, 0) 100%), initial;
    background-position-x: 385px, -940px, -120px, 495px, 122px, -420px, -620px, 520px, initial;
    background-position-y: -24px, 290px, 250px, -44px, -120px, 120px, 0px, -250px, initial;
    background-size: initial, initial, initial, initial, initial, initial, initial, initial, initial;
    background-repeat: initial, initial, initial, initial, initial, initial, initial, initial, initial;
    background-attachment: initial, initial, initial, initial, initial, initial, initial, initial, initial;
    background-origin: initial, initial, initial, initial, initial, initial, initial, initial, initial;
    background-clip: initial, initial, initial, initial, initial, initial, initial, initial, initial;
    background-color: rgb(169, 96, 238);
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: bottom;
    z-index: 1;
}

header {
    padding-left: 24px;
    height: 64px;
    z-index: 999;
}
@media(min-width: 1024px) {
    header {
        padding-left: 4vh;
    }
}
.logobox {
    height: 32px;
    cursor: pointer;
}
@media(min-width: 1024px) {
    .logobox {
        height: 36px;
    }
}

.body {
    width: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    margin: 0 auto;
    padding: 0px 0px;
}
@media(min-width: 1024px) {
    .body {
        max-height: calc(100vh - 128px);
        width: 80%;
        padding: 0;
    }
}

footer {
    padding-bottom: calc(23vh + 24px);
    position: relative;
    max-height: 64px;
}
@media(min-width: 1024px) {
    footer {
        padding-bottom: 24px;
    }
}
.new {
    z-index: 100;
    animation: .8s ease 1 normal both running kiki;
    animation-delay: 1s;    
}
p {
    all: unset;
}

/**/
.steppers {
    margin-top: 18px;
}
@media(min-width: 1024px) {
    .steppers {
        margin-top: -32px;
        background-color: transparent;
    }
}

.StepperItem {
  cursor: pointer;
  border: none;
  width: 120px;
  background-color: transparent !important;
}
.StepperItem[data-disabled] {
  pointer-events: none;
}
.StepperTrigger {
  background-color: transparent;
  border: none;  
}
.StepperIndicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  width: 40px;
  height: 40px;
  color: #333;
  background-color: var(--contrast_bg);
  box-shadow: var(--themed-border);
}
.StepperIcon {
  width: 20px;
  height: 20px;
}
.StepperItem[data-disabled] .StepperIndicator {
    background-color: rgba(0, 0, 0, 0.010);
}
.StepperItem[data-state="active"] .StepperIndicator {
    box-shadow: 0 0 0 2px #005fcc46;
    animation: hehe .6s ease 1;
}
.StepperItem[data-state="completed"] .StepperIndicator {
  background-color: var(--bg);
}
h1 {
    all: unset;
}
h4 {
    all: unset;
}
.StepperTitle {
    position: relative;
}

.card {
    display: flex;
    flex-direction: column;
    z-index: 2;
    animation: .4s ease 1 normal both running RmeheTop;
    animation-delay: .4s;
    height: fit-content;
    padding: 0 48px;
    margin: 32px auto 0 auto;
    width: 100%;
    max-width: 600px;
}

.title {
    font-size: 28px;
    line-height: 1.1;
    letter-spacing: -0.0325em;
    text-align: center;
    margin-bottom: 24px;
}
.action {
    width: 100%;
    height: 44px;
}
.action.disabled {
    cursor: not-allowed;
}
.action.noallow {
    /* background-color: rgb(242, 242, 242); */
    opacity: 0.36;
}
.line {
    width: stretch;
    height: 1.25px;
    background-color: var(--gutil);
}
.inputRow {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 52px;
    min-height: fit-content !important;
    background-color: var(--contrast_bg);
    border: 1px solid var(--gutil);
    border-radius: 6px;
    padding-left: 8px;
    padding-top: 4px;
    position: relative;
}
@media(max-width: 1024px) {
    .inputRow {
        height: fit-content;
    }
    .emailInput {
        padding-left: 0px;
    }
}
.inputRow.invalid {
    outline: groove transparent;
    box-shadow: 0 0 0 2px #fa4b4bb2;
    animation: hehe .4s ease 1;
}
.inputRow .prefix {
    display: flex;
    justify-content: space-between;
}
.emailInput {
    border: none;
    color: var(--foreground);
    background-color: transparent;
}
.emailInput:focus {
    outline: none;
    border: none;
}
@keyframes hehehe {
    0% {
        box-shadow: 0 0 0 0px #005fcc46;
    }
    100% {
        box-shadow: 0 0 0 2px #005fcc46;
    }
}
@keyframes hehe {
    0% {
        opacity: 0;
        transform: translate(-10px);
    }
}
.inputRow:not(.invalid):has(> .emailInput:focus) {
    outline: groove transparent;
    box-shadow: 0 0 0 2px #005fcc46;
    animation: hehehe .4s ease 1;
}
.warning {
    align-items: center;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    display: flex;
    justify-content: start;
    z-index: 10;
    animation: .8s ease 1 normal both running kiki;
    animation-delay: .8s;
    transform: translateX(6px);
}
.warning a {
    all: unset;
    text-decoration: underline;
    cursor: pointer;
}
.warning a:hover {
    color: var(--foreground);
}
.warning span {
    margin-left: 8px;
}
.warning svg {
    fill: var(--mako2);
}
@keyframes kiki {
    0% {
        opacity: 0;
        animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
}
#sign {
    cursor: pointer;
    user-select: none;
}
#sign:hover {
    color: #000000 !important;
}
.check {
    position: absolute;
    top: 0;
    right: 8px;
    height: 100%;
    width: fit-content;
    display: flex;
    align-items: center;
}
.checkIcon {
    height: 24px;
    width: 24px;
    color: #e1e1e1;
}
.checkIcon.error {
    color: #fa4b4b;
}
.checkIcon.success {
    color: #00a11b;
    height: 20px;
    width: 20px;
}
.loader {
        width: 1.15rem;
        height: 1.15rem;
        border-radius: 50%;
        position: relative;
        animation: rotate 1s linear infinite
      }
      .loader::before , .loader::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        inset: 0px;
        border-radius: 50%;
        border: 2px solid #FFF;
        animation: prixClipFix 2s linear infinite ;
      }
      .loader::after{
        border-color: transparent;
        animation: prixClipFix 2s linear infinite , rotate 0.5s linear infinite reverse;
        inset: 6px;
      }

      @keyframes rotate {
        0%   {transform: rotate(0deg)}
        100%   {transform: rotate(360deg)}
      }

      @keyframes prixClipFix {
          0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
          25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
          50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
          75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
          100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
      }

.loader.input::before, .loader.input::after {
    border: 2px solid #e1e1e1;
}
.cardSection.signing .loader {
    width: 2.3rem;
    height: 2.3rem;
}
.cardSection.signing .loader::before, .cardSection.signing .loader::after {
    border: 2px solid var(--gutil);
}
.cardSection.signing {
    align-items: center;
    gap: 8px;
}
.cardSection.signed {
    align-items: center;
    gap: 8px;
}
.cardSection.mobilePayment {
    margin-top: 24px;
    margin-bottom: 24px;
}
.checkoutItem {
    width: 100%;
    display: flex;
    justify-content: start;
    border-radius: 6px;
}
.ico {
    height: 48px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--gutil);
    border-radius: 6px;
}
.ico svg {
    height: 24px;
    width: 24px;
}
.item {
    display: flex;
    flex-direction: column;
    margin-left: 6px;
}
.item .StepperTitle {
    color: var(--foreground);
}
.holdamount {
    margin-left: auto;
}
.amount {
    color: var(--foreground);
    cursor: pointer;
    position: relative; 
}
.amount.fade {
    animation: .8s ease 1 normal both running kiki;
    animation-delay: .25s;    
}
.strike {
    position: absolute;
    top: 8px;
    left: 0px;
    width: 0%;
    height: 2px;
    background-color: var(--candy);
    animation-name: Strike;
    animation-duration: .8s;
    animation-timing-function: cubic-bezier(0.79,0.14,0.15,0.86);
    animation-fill-mode: forwards;
}
@keyframes Strike {
    0% {
        width: 0%;
    }
    100% {
        width: 100%;
    }
}
.promo {
    display: flex;
    gap: 6px;
    position: relative;
    width: 100%;
}
.promo .action {
    height: 100%;
    max-width: 24%;
    padding-left: 6px;
    padding-right: 6px;
}
.action.build {
    margin-top: 12px;
}
.amountRow {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-top: 1.5px solid var(--gutil);
    display: flex;
    padding: 6px 0;
    padding-bottom: 0px;
}
.StepperTitle.promo-question {
    font-size: 14px;
    text-align: left;
    text-decoration: underline;
}
.StepperTitle.build {
    color: var(--foreground);
}
.bigText {
    background: linear-gradient(180deg, hsla(0, 0%, 93%, 1) 36%, #000000);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1;
    letter-spacing: -.05em;
    font-size: 64px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}
.backStage {
    background-color: var(--gutil);
    height: 32px;
    width: 32px;
    border-radius: 50%;
    position: absolute;
    top: calc(100% + 12px);
    left: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
}
.backStage:hover .icon {
    color: var(--foreground);
}
@media(max-width: 1023px) {
    .backStage.mountTop {
        top: 0px;
    }
}
@media(min-width: 1024px) {
    .backStage {
        top: 0px;
    }
}

.icon {
    scale: unset;
    height: 32px;
    width: 32px;
    transform: rotate(-90deg);
    color: var(--mako);
}
.tooltipContent {
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px !important;
  line-height: 1;
  color: hsla(0, 0%, 9%, 1);
  border: 1px solid var(--gutil);
  background-color: var(--contrast_bg) !important;
  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px; 
  user-select: none;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  font-family: "Inter";
  letter-spacing: -0.013em;
  font-weight: 440;
  font-variation-settings: "opsz" 28;  
}
.tooltipArrow {
    fill: var(--contrast_bg) !important;
}
#status-icon {
    height: 64px;
    width: 64px;
}

/**/
.qrtext {
    text-align: center;
    margin-top: -16px;
    margin-bottom: 12px;
}
.qrcode {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--bg);
    border-radius: 6px;
    box-shadow: var(--themed-border);
}
.pinHold {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    justify-content: center;
}
.twofaFallback {
    margin-top: 12px;
}
.toggleManual {
    border-radius: 8px;
    border: none;
    background-color: var(--gutil);
    cursor: pointer;
}
.toggleManual svg {
    transform: rotate(180deg);
    transition: transform 150ms ease;
}
.toggleManual.active svg {
    transform: rotate(0deg);
}
.toggleManual:hover {
    color: var(--foreground) !important;
}
.PinInputInput{
  text-align: center;
  line-height: 1;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: var(--themed-border);
  height: 40px;
  width: 40px;
  border-radius: 4px; 
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  font-family: "Geist Mono";
}
.PinInputInput:focus {
    outline: 1px solid var(--primary);
}
.PinInputInput:disabled {
  opacity: .5
}
.PinInputRoot{
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 8px;
  margin-top: 6px; 
  color: var(--foreground) !important;
}
.recovery-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
}
.recovery-modal {
    background-color: var(--contrast_bg);
    padding: 24px 32px;
    border-radius: 8px;
    border: 1px solid var(--gutil);
    width: clamp(240px, 44vw, 480px);
}
.recovery_code {
  font-weight: 500;
  font-size: 14px;
  padding: 12px 6px;
  border-radius: 4px;
  white-space: nowrap;
  height: 20px;
  display: inline-flex;
  align-items: center;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), inset 0 -.5px 0 #2397e48f;
  color: hsla(201 54% 35%);
  background-color: hsla(208 100% 95%);
  border-color: hsla(206 81% 85%);  
}
.error-message {
    color: #e5484d;
    margin: 12px 0;
}
.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 150ms ease-out, transform 150ms ease-out;
}
</style>